import { memo, useCallback } from "react";
import { useFormikContext } from "formik";
import { ProgressButton, ProgressButtonProps } from "../ui";

export const MimicFormSaveButton = memo<ProgressButtonProps>(({ children, ...props }) => {
  const { submitForm, isSubmitting } = useFormikContext() || {};
  const onClick = useCallback(async () => await submitForm?.(), [ submitForm ]);
  return (
    <ProgressButton
      type="submit"
      buttonType="primary"
      disabled={isSubmitting}
      onClick={onClick}
      {...props}
    >
      {children ?? "Save"}
    </ProgressButton>
  );
});